import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import "react-phone-number-input/style.css"
import { DELIVERY_OPTIONS } from "src/app/constants"
import DeliveryOrShippingForm from "./information/DeliveryOrShippingForm"
import PickupForm from "./information/PickupForm"
import SpecialEventsForm from "./information/SpecialEventsForm"
import analytics from "src/app/analytics"

export default function Information() {
  const navigate = useNavigate()
  const cart = useSelector((state) => state.checkout.cart)
  const { deliveryOption, specialEvent } = useSelector(
    (state) => state.checkout.options,
  )

  useEffect(() => {
    if (!deliveryOption) navigate("../options")

    document.title = "Information - Kakaako Wine - Checkout"

    let eventParam = { cart_id: cart.id, delivery_option: deliveryOption }
    if (specialEvent) eventParam = { ...eventParam, special_event: specialEvent }
    analytics.track("select_delivery_option", eventParam)

    analytics.track("page_view", {
      cart_id: cart.id,
      page_title: "Information",
      page_location: window.location.href,
    })
  }, [deliveryOption])

  if (deliveryOption === DELIVERY_OPTIONS.LOCAL_PICKUP) {
    return <PickupForm />
  }

  if (specialEvent) {
    return <SpecialEventsForm />
  }

  return <DeliveryOrShippingForm />
}
